import { GoogleOAuthProvider } from '@react-oauth/google';
import SentryErrorBoundary from 'components/SentryErrorBoundary';
import Snackbar from 'components/Snackbar';
import i18n from 'i18n';
import RefreshProvider from 'providers/RefreshProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import ThemeProviders from 'styles/ThemeProviders';
import Apollo from './apollo/providers/Apollo';
import App from './App';

const googleClientID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '';

ReactDOM.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <GoogleOAuthProvider clientId={googleClientID}>
        <I18nextProvider i18n={i18n}>
          <Apollo>
            <RefreshProvider>
              <ThemeProviders>
                <Snackbar />
                <App />
              </ThemeProviders>
            </RefreshProvider>
          </Apollo>
        </I18nextProvider>
      </GoogleOAuthProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
